var map = {
	"./cartIcon.svg": 2601,
	"./catalogIcon.svg": 5567,
	"./contactIcon.svg": 5068,
	"./logo.svg": 9310,
	"./openCtegoryIcon.svg": 3830,
	"./product/chat_bubble.svg": 2676,
	"./product/check_small.svg": 593,
	"./product/favourite 3.svg": 6557,
	"./product/thumb_down.svg": 97,
	"./product/thumb_up.svg": 6755
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7429;